module.exports = __webpack_public_path__ + "img/incae.83424e4e.jpg";